/** H7 greybox start town B (เหมืองเงาผา, origin B): see townGrey.ts. */
import { townLayout, townZone } from './townGrey';

export const TOWN_B_LAYOUT = townLayout('town-b', 701);
export const TOWN_B_ZONE = townZone('town-b', 'เหมืองเงาผา', 701, [0.96, 0.98, 1.04]);
